var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-skeleton",
    "class": {
      'table-skeleton--dense': _vm.dense
    }
  }, [_c('div', {
    staticClass: "table-skeleton__table"
  }, [_c('div', {
    staticClass: "table-skeleton__head"
  }, [_c('div', {
    staticClass: "table-skeleton__row table-skeleton__row--head"
  }, [_vm.showSelect ? _c('div', {
    staticClass: "table-skeleton__cell table-skeleton__cell--checkbox"
  }, [_c('div', {
    staticClass: "table-skeleton__line table-skeleton__line--checkbox"
  })]) : _vm._e(), _vm._l(_vm.columnCount, function (col, idx) {
    return _c('div', {
      key: 'head-' + col,
      staticClass: "table-skeleton__cell"
    }, [_vm.headerLabels && _vm.headerLabels[idx] ? _c('span', {
      staticClass: "table-skeleton__header-text"
    }, [_vm._v(_vm._s(_vm.headerLabels[idx]))]) : _c('div', {
      staticClass: "table-skeleton__line table-skeleton__line--header"
    })]);
  })], 2)]), _c('div', {
    staticClass: "table-skeleton__body"
  }, _vm._l(_vm.rowCount, function (row) {
    return _c('div', {
      key: 'row-' + row,
      staticClass: "table-skeleton__row"
    }, [_vm.showSelect ? _c('div', {
      staticClass: "table-skeleton__cell table-skeleton__cell--checkbox"
    }, [_c('div', {
      staticClass: "table-skeleton__line table-skeleton__line--checkbox"
    })]) : _vm._e(), _vm._l(_vm.columnCount, function (col) {
      return _c('div', {
        key: 'cell-' + row + '-' + col,
        staticClass: "table-skeleton__cell"
      }, [_c('div', {
        staticClass: "table-skeleton__line",
        style: {
          width: _vm.cellWidths[(row + col) % _vm.cellWidths.length]
        }
      })]);
    })], 2);
  }), 0)]), _vm.showFooter ? _c('div', {
    staticClass: "table-skeleton__footer"
  }, [_c('div', {
    staticClass: "table-skeleton__line table-skeleton__line--footer"
  })]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }